<template>
    <div>
        
        <div class="statistcs-container">
            <el-row :gutter="16">
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="'1,750'">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        Total Requests
                        <el-tooltip
                        effect="dark"
                        content="Number of total units prices "
                        placement="top"
                        >
                        <el-icon style="margin-left: 4px" :size="12">
                            <Warning />
                        </el-icon>
                        </el-tooltip>
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>than yesterday</span>
                    <span class="green">
                        24%
                        <el-icon>
                        <CaretTop />
                        </el-icon>
                    </span>
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="requests.total">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        Total Requests
                        <el-tooltip
                        effect="dark"
                        content="Number of Total Units"
                        placement="top"
                        >
                        <el-icon style="margin-left: 4px" :size="12">
                            <Warning />
                        </el-icon>
                        </el-tooltip>
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>month on month</span>
                    <span class="red">
                        12%
                        <el-icon>
                        <CaretBottom />
                        </el-icon>
                    </span>
                    </div>
                </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="statistic-card">
                <el-statistic :value="72000" title="New transactions today">
                    <template #title>
                    <div style="display: inline-flex; align-items: center">
                        New transactions today
                    </div>
                    </template>
                </el-statistic>
                <div class="statistic-footer">
                    <div class="footer-item">
                    <span>than yesterday</span>
                    <span class="green">
                        16%
                        <el-icon>
                        <CaretTop />
                        </el-icon>
                    </span>
                    </div>
                    <div class="footer-item">
                    <el-icon :size="14">
                        <ArrowRight />
                    </el-icon>
                    </div>
                </div>
                </div>
            </el-col>
            </el-row>
        </div>
        
        
        <div class="table-main-actions-container">
            <div class="table-actions-container">
            <div class="row">
                <div class="sorting-container col-4">
                <el-button
                        type="info"
                        link
                        @click="refreshUsers"
                        >
                        <font-awesome-icon icon="fa-solid fa-compass-drafting"/> <span style="margin-left:5px;"> All Requests </span>
                        </el-button>
                </div>
                <div class="col-8 table-actions">
                    <ul class="actions-list" v-if="requests.data">
                        <li><el-button :class="'add-btn danger'" type="danger" @click="openAddForm"><font-awesome-icon icon="fa-solid fa-plus"/> Add New</el-button></li>
                        <li >
                            <el-button
                                v-if="!isSearch"
                                type="info"
                                link
                                @click="isSearch = !isSearch"
                            >
                            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Search
                            </el-button>
                            <el-input
                                v-if="isSearch"
                                v-model="searchValue"
                                style="max-width: 300px"
                                placeholder="Please input"
                                class="input-with-select"
                            >
                            <template #append>
                                <el-button style="width: 30px;" @click="searchRequests">
                                <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                                </el-button>
                            </template>
                            </el-input>
                        </li>
                    </ul>
                </div>
            </div>
            </div>
        </div>



        <el-table :row-class-name="tableRowClassName" v-loading="isLoading" element-loading-text="Loading..." element-loading-background="rgba(255, 255, 255, 0.8)" :data="requests.data" style="width: 100%" :header-row-class-name="'table-header-style'" :header-cell-class-name="'table-header-cell-style'" :highlight-current-row="true" :cell-class-name="'custom-cell'">
        <el-table-column type="selection" width="55"  fixed="left"/>
        <el-table-column 
          label="ID" 
          prop="id" 
          width="60"
          
        />

        <el-table-column 
          label="Username" 
          width="200"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            {{
              scope.row.is_edit_active ? "" : scope.row.user_name
            }}
            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.user_name"

              placeholder="user name"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column 
          label="User number" 
          width="150"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <el-button v-if="!scope.row.is_edit_active" text :size="'small'" circle @click="openWhatsApp(scope.row.clientNumber , scope.row)">

              <font-awesome-icon icon="fa-brands fa-square-whatsapp" size="xl" style="color: #008f64;" />
            </el-button>
            {{  scope.row.is_edit_active ? "" : scope.row.user_phone }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.user_phone"

              placeholder="user number"
              clearable
            />
          </template>
        </el-table-column>
        <!-- Repeat the above pattern for other columns as necessary -->
        <el-table-column label="Name" prop="name" width="150" :show-overflow-tooltip="true" />
        <el-table-column width="120" :show-overflow-tooltip="true" >
          <template #header>
            Type 
            <FilterPopover
              :filterKey="'type'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.type"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Type"
                    
                  >
                    <el-option
                      v-for="type in lists.types"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                    />
                  </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.type }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.type"
              filterable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Type"
              
            >
              <el-option
                v-for="type in lists.types"
                :key="type.id"
                :label="type.name"
                :value="type.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="100" >
          
          <template #header>
            Area 
            <FilterPopover
              :filterKey="'size'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.size"
                type="number"
                placeholder="size"
                clearable
               />
            </FilterPopover>

          </template>
          
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.size }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.size"
              clearable
              type="number"
              placeholder="size "
              
            />
          </template>
        </el-table-column>
        <el-table-column  width="100" >
          <template #header>
            Land 
            <FilterPopover
              :filterKey="'land'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.land"
                type="number"
                placeholder="land"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.land }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.land"
              type="number"
              placeholder="land "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="130" >
          <template #header>
            Bedrooms 
            <FilterPopover
              :filterKey="'bedrooms'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.bedrooms"
                type="number"
                placeholder="beds"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.bedrooms }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.bedrooms"
              type="number"
              placeholder="bedrooms "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="130" >
          <template #header>
            Bathrooms 
            <FilterPopover
              :filterKey="'bathrooms'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.bathrooms"
                type="number"
                placeholder="baths"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.bathrooms }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.bathrooms"
              type="number"
              placeholder="bathrooms "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="120" >
          <template #header>
            Floor 
            <FilterPopover
              :filterKey="'level'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.level"
                type="number"
                placeholder="Floor"
                clearable
              />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.level }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.level"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Level"
              
            >
              <el-option
                v-for="level in lists.levels"
                :key="level.id"
                :label="level.name"
                :value="level.name"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true"  >
          <template #header>
            Downpayment 
            <FilterPopover
              :filterKey="'down_payment'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.down_payment_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.down_payment_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.down_payment) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.down_payment"
              type="text"
              placeholder="downpayment "
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true">
          <template #header>
            Installments 
            <FilterPopover
              :filterKey="'quarter_installment'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.quarter_installment_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.quarter_installment_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.quarter_installment) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.quarter_installment"
              type="text"
              placeholder="quarter installment "
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true" >
          <template #header>
            Total price 
            <FilterPopover
              :filterKey="'price'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.price_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.price_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.price) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.price"
              type="text"
              placeholder="price"
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="150" :show-overflow-tooltip="true">
          <template #header>
            Finishing 
            <FilterPopover
              :filterKey="'finishing'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.finishing"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Finishing"
                    
                  >
                    <el-option
                      v-for="type in lists.finishings"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                    />
                  </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.finishing }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.finishing"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Finishing"
              
            >
              <el-option
                v-for="item in lists.finishings"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true">
          <template #header>
            Location 
            <FilterPopover
              :filterKey="'city'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.city"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose City"
                    
                  >
                    <el-option
                      v-for="type in lists.cities"
                      :key="type.id"
                      :label="type.name"
                      :value="type.name"
                    />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.city }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.city"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose city"
              
            >
              <el-option
                v-for="city in lists.cities"
                :key="city.id"
                :label="city.name"
                :value="city.name"
              />
            </el-select>
            
          </template>
        </el-table-column>

        <el-table-column width="120" >
          <template #header>
            Category
            <FilterPopover
              :filterKey="'category'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.category"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Category"
                    
                  >
                  <el-option
                    v-for="cat in categories"
                    :key="cat.index"
                    :label="cat"
                    :value="cat"
                  />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.category }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.category"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Category"
              
            >
              <el-option
                v-for="cat in categories"
                :key="cat.index"
                :label="cat"
                :value="cat"
              />
            </el-select>
            
          </template>
        </el-table-column>



        <el-table-column label="Description"  width="200" :show-overflow-tooltip="false" >
          <template #default="scope">
            <el-popover
              v-if="!scope.row.is_edit_active"
              placement="left-start"
              title="Description"
              :width="250"
              trigger="hover"
              :content="scope.row.description"
            >
              <template #reference>
                {{scope.row.description}}
                
              </template>
            </el-popover>
            <el-input
                  v-if="scope.row.is_edit_active"
                  v-model="Edited_model.description"
                  :rows="1"
                  type="textarea"
                  placeholder="Description"
                />
          </template>
        </el-table-column>
        
        <el-table-column align="center" fixed="right" min-width="120">
          <template #header>
            Actions
          </template>
          <template #default="scope">
            
            <el-button size="small" @click="({})" :icon="Edit" 
            circle v-if="!scope.row.is_edit_active"/>
            
            <el-button
              size="small"
              type="danger"
              :icon="Delete" 
              circle
              @click="deleteRequest(scope.row.id)"
              v-if="!scope.row.is_edit_active"
            />
            <el-button type="success" :icon="Check" circle v-if="scope.row.is_edit_active" @click="EditUnit(scope.$index)"/>
            <el-button type="info" :icon="Close" circle @click="closeEdit(scope.$index)" v-if="scope.row.is_edit_active"/>
            
            
            
          </template>
        </el-table-column>
      
      </el-table>

        

        <div class="pagination-container">
            <el-pagination
            :page-size="requests.per_page"
            :pager-count="11"
            :size="'small'"
            layout="prev, pager, next"
            :total="requests.total"
            :background="true"
            :disabled="isDisabled"
            :current-page="page"
            @current-change="paginationChanged"
            />
      </div>
    </div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import FilterPopover from '../components/filterPopover.vue';
import numeral from 'numeral';
import { useStore } from 'vuex';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  Search ,
  View,
  HomeFilled,
} from '@element-plus/icons-vue'

import { useRouter } from 'vue-router';
export default {
    name: 'Requests',
    components: {
        FilterPopover
    },
    setup(){
        const store = useStore();
        const page = ref(1);
        const isLoading = ref(false);
        const requests = ref([]);
        const Edited_model = ref({});
        const isSearch = ref(false);
        const isDisabled = ref(false);
        const lists = ref([]);
        const isAdd = ref(false);
        const searchValue = ref('');
        const ruleFormRef = ref(null);
        const isAddFormLoading = ref(false);
        const router = useRouter();
        const filtersKeys = ref({
            
            type:{
            title:'Filter Type' ,
            isFilter:false,
            },
            category:{
            title:'Filter Category' ,
            isFilter:false,
            },
            delivery_date:{
            title:'Filter Delivery date' ,
            isFilter:false,
            },
            city:{
            title:'Filter Location' ,
            isFilter:false,
            },
            price:{
            title:'Filter Price' ,
            isFilter:false,
            },
            land:{
            title:'Filter Land' ,
            isFilter:false,
            },
            down_payment:{
            title:'Filter Downpayment' ,
            isFilter:false,
            },
            quarter_installment:{
            title:'Filter Installments' ,
            isFilter:false,
            },
            level:{
            title:'Filter Level' ,
            isFilter:false,
            },
            bedrooms:{
            title:'Filter Beds' ,
            isFilter:false,
            },
            bathrooms:{
            title:'Filter Baths' ,
            isFilter:false,
            },
            size:{
            title:'Filter Size' ,
            isFilter:false,
            },
            finishing:{
            title:'Filter finishing' ,
            isFilter:false,
            },
        });
        const filter_model = reactive({
            bedrooms:null,
            bathrooms:null,
            developer_id: null,
            project_id: null,
            finishing: null,
            services: null,
            size: null,
            land: null,
            location: null,
            city:null,
            type: null,
            category: null,
            description: null,
            price_start:null,
            price_end:null,
            name:null,
            down_payment_start:null,
            down_payment_end:null,
            quarter_installment_start:null,
            quarter_installment_end:null,
            level:null,
            clientName:null,
            clientNumber:null,
            delivery_date:null,
            license:null,
            user_name:null,
            updated_at:null,
            updated_at_start:null,
            updated_at_end:null,
        });
        const rules = reactive({
            first_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
            last_name: [
                { required: true, message: '@Required', trigger: 'blur' },   
            ],
        });
        const add_model = reactive({
            first_name:null,
            last_name:null,
        });

        
        const searchRequests = async () => {
            if(searchValue.value && searchValue.value != " " ){
                isLoading.value = true;
                const value = searchValue.value;
                const pageno = page.value;
                await store.dispatch('requests/searchRequests' , { value:value , page:pageno})
                requests.value = store.getters['requests/getRequests'];
                isLoading.value = false;
            }
        };
        const openAddForm = () => {
            add_model.first_name , add_model.last_name , add_model.account_type , add_model.registeration_type , add_model.password , add_model.email , add_model.phone= null;
            isAdd.value = true;
        };
        const openWhatsApp = (  cellValue ) => {
            const message = `*Hi, This is TAP Egypt `;
            const url = `https://wa.me/${cellValue}?text=${encodeURIComponent(message)}`;
            window.open(url, '_blank');  // Opens WhatsApp in a new tab or app
        };
        const deleteRequest = async (id) => {
            ElMessageBox.confirm(
            'Are you sure delete this request. Continue?',
            'warning',
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }
            )
            .then( async () => {
                isLoading.value = true;
                //await store.dispatch('requests/deleteRequest' , id);
                ElMessage({
                type: 'success',
                message: 'Delete successfull',
                })
                requests.value = store.getters['requests/getRequests'];
                isLoading.value = false;
            })
            .catch(() => {
                isLoading.value = false;
                ElMessage({
                type: 'info',
                message: 'Delete canceled',
                })
            })
        };
        const paginationChanged = async (value) => {
            page.value= value;
            const pageno = page.value;
            isLoading.value = true;
            isDisabled.value = true;
            const svalue = searchValue.value;
            if(svalue){
                await store.dispatch('requests/searchRequests' , { value:svalue , page:pageno});
            }
            else{
                await store.dispatch('requests/fetchRequests' , pageno);
            }
            requests.value = store.getters['requests/getRequests'];
            isDisabled.value = false;
            isLoading.value = false;
        };
        // Method to navigate to the units page with userId
        const goToUnits = (userId) => {
            router.push({ name: 'units', params: { userId } });
        };
        onMounted(async () => {
            isLoading.value = true;
            await store.dispatch('requests/fetchRequests' , page.value);
            requests.value = store.getters['requests/getRequests'];
            isLoading.value = false;
        });
        const openEditForm = (row) => {
            //get backup of row
            Edited_model.value = {...requests.value.data[row]} ;
            //close all forms and open only selected row
            requests.value.data.map(user => user.is_edit_active = false);
            requests.value.data[row].is_edit_active = true;
            delete Edited_model.value.photo_link;
        }
        const closeEdit = (row) => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            ElMessage({
                type: 'info',
                message: 'Canceld.',
            })
            })
            .catch(() => {
            Edited_model.value = {};
            requests.value.data[row].is_edit_active = false;
            ElMessage({
                type: 'info',
                message:'Changes Discribed',
            })
            })
            
        };
        const EditUser = async (index) => {
            isLoading.value = true;

            await store.dispatch('usersupdateUser' , Edited_model.value);
            await store.dispatch('requests/fetchRequests' , page.value);
            requests.value = store.getters['requests/getRequests'];
            //units.value.data[index] = Edited_model.value;
            requests.value.data[index].is_edit_active = false;
            isLoading.value = false;
        };
        const refreshUsers = async () => {
            page.value = 1;

            isLoading.value = true;
            searchValue.value = '';
            await store.dispatch('requests/fetchRequests' , page.value);
            requests.value = store.getters['requests/getRequests'];
            isLoading.value = false;
        };
        const handleAddUserClose = () => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            isAdd.value = false;
            resetForm();
            ElMessage({
                type: 'info',
                message: 'Changes Discribed',
            })
            })
            .catch(() => {
            
            ElMessage({
                type: 'info',
                message:'Canceld',
            })
            })
            
        };
        const handleAddSubmit = async () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;
                // Validate the form
                await form.validate(async (valid, fields) => {
                    if (valid) {
                        try {
                            isAddFormLoading.value = true;

                            

                            

                            // Send the form data to the store's action
                            await store.dispatch('requests/addNewUser', add_model);
                            resetForm();
                            
                            isAdd.value = false;
                            ElMessage({
                                type: 'success',
                                message: 'User is Added Successfully',
                            })
                            
                        } catch (error) {
                            ElMessage({
                            type: 'error',
                            message: 'Something Went Wrong ...',
                            })
                        } finally {
                            isAddFormLoading.value = false;
                        }
                    } else {
                        console.log('Form is invalid:', fields);
                    }
                });
        };
        const resetForm = () => {
            const form = ruleFormRef.value; // Access the form instance
            if (!form) return;

            // Reset the form fields
            form.resetFields();
        };
        const addImageToList = (file,fileList)=> {
            /* add_model.photo_link = file.raw;
            console.log(add_model); */
        };
        const formatPrice = (cellValue) => {
            return numeral(cellValue).format('$0,0'); // Formats as currency
        };
        const handleTogglePopover = (filterKey) => {
            for (const key in filtersKeys.value) {
            if (key !== filterKey) {
                filtersKeys.value[key].isFilter = false;
            }
            }
        };
        const handleCanclePopover = (filterKey) => {
            filter_model[filterKey] = null;
        }
        return {
            handleTogglePopover,
            handleCanclePopover,
            lists,
            filter_model,
            filtersKeys,
            router,
            goToUnits,
            isAdd,
            add_model,
            store,
            requests,
            page,
            isDisabled,
            isLoading,
            Edited_model,
            isSearch,
            searchValue,
            isAddFormLoading,
            ArrowRight,
            CaretBottom,
            CaretTop,
            Check,
            HomeFilled,
            Warning,
            Delete,
            Edit,
            Close,
            Search ,
            View,
            ruleFormRef,
            resetForm,
            rules,
            openEditForm,
            closeEdit,
            EditUser,
            refreshUsers,
            paginationChanged,
            searchRequests,
            deleteRequest,
            openAddForm,
            handleAddUserClose,
            handleAddSubmit,
            addImageToList,
            openWhatsApp,
            formatPrice,
        }
    }
}
</script>

<style lang="scss">
.el-drawer{
    .upload-project-demo{
        width: 100%;
    }
  ::-webkit-scrollbar {
    width: 4px;
    transition: 0.2s ease-in-out;
  }
  /* ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    transition: 0.2s ease-in-out;
  }
  &:hover{
    ::-webkit-scrollbar-thumb {
      transition: 0.2s ease-in-out;
      background: #034750;
    }
  } */
}
.add-project-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 23% !important;
    }
  }
}
@import '../assets/styles/table.scss';


.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-list .el-upload-list__item {
  cursor: move;
}

</style>
  
  // statistics Style
  <style scoped>
  .statistcs-container{
    margin-bottom: 50px;
  }
  :global(h2#card-usage ~ .example .example-showcase) {
    background-color: var(--el-fill-color) !important;
  }
  
  .el-statistic {
    --el-statistic-content-font-size: 28px;
  }
  
  .statistic-card {
    height: 100%;
    padding: 15px;
    border-radius: 10px;
    background-color: #d8e5e78f;
    /* border: solid 1px #f1f1f1; */
  }
  
  .statistic-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--el-text-color-regular);
    margin-top: 16px;
  }
  
  .statistic-footer .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .statistic-footer .footer-item span:last-child {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
  }
  
  .green {
    color: var(--el-color-success);
  }
  .red {
    color: var(--el-color-error);
  }
  </style>